import React from 'react';
import { ITableDataSource } from 'models/table';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { Chips, EChipsVariants } from 'components/atoms/Chips';
import Button from 'components/atoms/Button';
import { EButtonSizes, EButtonVariants } from 'constants/Buttons';
import { useTranslations } from 'hooks/useTranslations';
import { emptyFieldHolder } from 'components/molecules/CardList';

interface ILegalEntityAddressTableCard {
  data: ITableDataSource;
  onCheck: (data: ITableDataSource) => void;
  isChecked: boolean;
}

const SelectLocationAddressTableCard = ({
  data,
  onCheck,
  isChecked,
}: ILegalEntityAddressTableCard) => {
  const { t } = useTranslations();

  return (
    <Grid
      container
      columnSpacing={3}
      sx={{
        backgroundColor: colors.gray100,
        border: `1px solid ${colors.gray200}`,
        borderRadius: '4px',
        overflow: 'hidden',
        padding: '20px',
        rowGap: 3,
      }}
    >
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('legalEntityDetails.addressTab.addressType.column')}
        </Typography>
        {data.typeUniqueId ? (
          <Chips text={data.typeUniqueId} variant={EChipsVariants.primary} />
        ) : (
          <Typography variant="body2">-</Typography>
        )}
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('legalEntityDetails.addressTab.storageAddress.column')}
        </Typography>
        <Typography variant="body2">
          <Chips
            text={
              data.storage
                ? t('general.confirmation.yes.button')
                : t('general.confirmation.no.button')
            }
            variant={data.storage ? EChipsVariants.success : EChipsVariants.inactive}
          />
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('legalEntityDetails.addressTab.address.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.line1)}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('legalEntityDetails.addressTab.city.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.city)}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('legalEntityDetails.addressTab.stateProvince.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.regionUniqueId)}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('legalEntityDetails.addressTab.zipPostalCode.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.postalCode)}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('legalEntityDetails.addressTab.gps.column')}
        </Typography>
        <Typography variant="body2">{`${emptyFieldHolder(data.gps)}`}</Typography>
      </Grid>
      <Grid
        container
        size={{ xs: 12 }}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTop: {
            xs: `1px solid ${colors.primary100}`,
            lg: 'none',
          },
          mt: {
            xs: 0,
          },
          pt: {
            xs: 2,
          },
        }}
        spacing={2}
      >
        <Grid size={{ xs: 12, sm: 6 }} sx={{ mb: { xs: 2, sm: 0 } }}>
          <Typography variant="button" sx={{ textTransform: 'uppercase' }}>
            {t('legalEntityDetails.addressTab.action.column')}:{' '}
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, sm: 3 }}>
          <Button
            label={isChecked ? t('general.unselect.text') : t('general.select.text')}
            variant={EButtonVariants.outlined}
            onClick={() => onCheck(data)}
            size={EButtonSizes.small}
            fullWidth
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export { SelectLocationAddressTableCard };
